// https://vuex.vuejs.org/en/state.html
export default {
  currentVariantId: state => state.currentVariantId,
  familyCompletude: state => state.familyCompletude,
  currentMarketplace: state => state.currentMarketplace,
  completudes: state => state.completudes,
  families: state => state.families,
  bymarkerplaces: state => state.completudeMarketplaces,
};
